import styled from 'styled-components';

export const Container = styled.div`
  & > header {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    text-align: start;

    & > .title {
      font-weight: 600;
    }

    & > .subtitle {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.graySubTitle};
      line-height: normal;
    }
  }
`;

export const Content = styled.div`
  font-size: 0.875rem;
  text-align: start;

  input[name='inputRenewValue'] {
    width: 14.375rem;
  }

  & > .item {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;

    .textFieldLimitValue {
      display: none;
    }

    & > .item-title {
      font-weight: 600;
    }

    & > .renew-value {
      font-size: 1rem;
      margin: 1rem 0;
      padding-bottom: 0.75rem;
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray6};
      max-width: 20rem;

      & > input {
        padding: 0.25rem;
      }
    }

    & > .doc-item {
      color: ${({ theme }) => theme.colors.graySubTitle};
    }

    & > .upload-area {
      width: 100%;
      margin-top: 1.4rem;
      span {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
